import * as actionsType from "../actions/types";

const initialState = {};

export default function productsReducer(state=initialState, action) {
    switch(action.type) {
        case actionsType.SET_PRODUCTS:
            const {list} = action.payload;
            return {...state, list}
        default:
            return state;
    }
}